import { WrappedFieldProps } from "redux-form";

import { FormError, FormGroup, FormLabel, TextArea as FormTextArea } from "src/styled";

interface Props extends WrappedFieldProps {
  disabled?: boolean;
  isLoading?: boolean;
  label?: string;
  margin?: string;
  maxLength?: number;
  placeholder?: string;
  rows?: number;
  scrollYVisible?: boolean;
}

const TextArea = ({
  disabled,
  input,
  isLoading,
  label,
  margin,
  meta: { asyncValidating, submitFailed, error },
  placeholder,
  ...props
}: Props) => {
  return (
    <FormGroup hasValue={input.value} isLoading={isLoading || asyncValidating} margin={margin}>
      {!!label && <FormLabel>{label}</FormLabel>}
      <FormTextArea {...input} placeholder={placeholder} disabled={disabled} {...props} />

      {submitFailed && error && <FormError>{error}</FormError>}
    </FormGroup>
  );
};

export default TextArea;
